import { render, staticRenderFns } from "./UserPaymentMethods.vue?vue&type=template&id=d6d48584"
import script from "./UserPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./UserPaymentMethods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports